import { RouterProvider } from 'react-router'
import { router } from './router'

// Wurzel der Oberfläche. Anbieter (UI-Kit, API-Schicht, Abfrage-Cache) hängen an der Wurzel-Route (shell/runtime.tsx),
// damit die Schaukästen unter /kit ihre eigenen Anbieter mitbringen können.
export function App() {
  return <RouterProvider router={router} />
}
